import { useEffect, useRef } from 'react';
import { trackEvent } from './Analytics';

export function useViewTimer(ref, sectionName) {
  const startTime = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          startTime.current = Date.now();
        } else if (startTime.current) {
          const duration = Date.now() - startTime.current;
          const seconds = Math.round(duration / 1000);
          trackEvent('Section View', `Viewed ${sectionName}`, `${seconds}s`);
          startTime.current = null;
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref, sectionName]);
}
